import { defineComponent as _defineComponent } from 'vue'
import { nextTick } from 'vue'
import type { NewRirekishoExampleSentence } from '@/composables/format-edit/useNewRirekishoFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewRirekishoExampleSentenceDialog',
  props: {
    value: { type: Boolean },
    name: null,
    items: null,
    showOverwriteWarning: { type: Boolean, default: false },
    overwriteWarning: { default: '例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。' }
  },
  emits: ["input", "select"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void
  (e: 'select', item: NewRirekishoExampleSentence): void
}), expose: any, slots: any, attrs: any }) {





function onOpened() {
  nextTick(() => {
    document
      .querySelectorAll('.new-rirekisho-example-sentence-dialog__container')
      .forEach((el) => {
        ;(el as HTMLElement).scrollTop = 0
      })
  })
}

function onSelect(item: NewRirekishoExampleSentence) {
  emit('select', item)
  emit('input', false)
}

return { __sfc: true,emit, onOpened, onSelect }
}

})